module.exports = __webpack_public_path__ + "static/media/Home-warranty-blue.1931aebc.svg";